import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import { userportal as routes, backoffice, createBackofficeLink, BLOG_URL } from 'shared/routes';
import Logo from 'shared/components/Logo';
import styles from './Footer.module.scss';

/*
<div className={styles.social}>
  <a href="#" title=""><i className="lab la-facebook-f" /></a>
  <a href="#" title=""><i className="lab la-twitter" /></a>
  <a href="#" title=""><i className="lab la-linkedin-in" /></a>
</div>
*/

const Footer = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <footer className={styles.footer} onClick={onClick}>
      <div className={`container ${styles.container}`}>
        <div className="row">
          <div className={`col-xl-3 col-lg-3 col-md-12 col-sm-12 ${styles.logoWrapper}`}>
            <Link to={routes.root}><Logo className={styles.logo} /><span>{t('common:name')}</span></Link>
          </div>
          <div className="col-xl-9 col-lg-9 col-md-12 col-sm-12">
            <div className={styles.links}>
              <Link to={routes.about}>{t('userportal:footer.about', { name: t('common:name') })}</Link>
              <Link to={routes.howItWorks}>{t('userportal:footer.howItWorks')}</Link>
              <Link to={routes.tos}>{t('userportal:footer.tos')}</Link>
              <Link to={routes.gdpr}>{t('userportal:footer.gdpr')}</Link>
              <a href={BLOG_URL} target="_blank" rel="noopener noreferrer">{t('userportal:footer.blog')}</a>
              <Link to={routes.contact}>{t('userportal:footer.contact')}</Link>
              <a className={styles.backoffice} href={createBackofficeLink(backoffice.root)}>{t('userportal:navigation.forEmployers')}</a>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.copy}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <span>© {new Date().getFullYear()} {t('common:owner.name')}</span>
              <span>
                <Trans i18nKey="common:zamacore">
                  <a href="https://www.zamacore.cz" target="_blank" rel="noopener noreferrer" />
                </Trans>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
